import type React from 'react';

import { TextField } from '@change/ds-forms';

import { useTitleData } from './hooks';

export const Title: React.FC = () => {
	const { data, actions } = useTitleData();

	return (
		<div id="edit_ask" className="pt-4">
			<TextField
				type="text"
				label=""
				size="large"
				name="title-input"
				value={data.value}
				errorMessage={data.error}
				onChange={actions.handleChange}
				placeholder={data.placeholder}
				data-qa="title-textfield"
				isInvalid={!!data.error}
				validationBehavior="aria"
				maxLength={90}
				isRequired
			/>
		</div>
	);
};
